export type PublicKey = string

export type CardId = string

export enum CardBrand {
  VISA = 'Visa',
  MASTER = 'MasterCard',
  JCB = 'JCB',
  AMEX = 'American Express',
  DINERS = 'Diners Club',
  DISCOVER = 'Discover',
}

export interface Card {
  id: CardId
  object: 'card' // 固定値
  address_city: string | null
  address_line1: string | null
  address_line2: string | null
  address_state: string | null
  address_zip: string | null
  address_zip_check: 'passed' | 'unchecked' // 他にもあるかも
  brand: CardBrand
  country: string | null
  created: number
  customer: null // Customerオブジェクトが入るかも？;
  cvc_check: 'passed' | 'unchecked' // 他にもあるかも
  exp_month: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  exp_year: number
  fingerprint: string
  livemode: false
  metadata: object
  last4: string
  name: string | null
}

export interface CardTokenizeParams {
  name: string
  elements: any
}

export type TokenId = string

export interface Token {
  id: TokenId
  object: 'token' // 固定値
  card: Card
  created: number
  livemode: boolean
  used: boolean
}
